import styled from 'styled-components';

export const Content = styled.span`
  text-align: center;
  width: 540px;
`;

export const ContentText = styled.span`
  margin: ${({ theme }) => `${theme.spacing.km1} ${theme.spacing.km16} ${theme.spacing.km0} ${theme.spacing.km16}`};
`;
